<div class="auth-page">
  <mat-card class="auth-card">
    <header class="card-header">
      <div class="brand">
        <div class="brand-icon">R</div>
        <div>
          <h1>
            {{
              t(
                isCreatingAccount() ? 'header.title.signUp' : 'header.title.signIn',
                { target: tenantName() ?? t('brand.name') }
              )
            }}
          </h1>
          <p class="subtitle">
            <ng-container *ngIf="isCreatingAccount(); else signInSubtitle">
              {{
                tenantName()
                  ? t('header.subtitle.signUpWithTenant', { target: tenantName() ?? '' })
                  : t('header.subtitle.signUpDefault', { brand: t('brand.name') })
              }}
            </ng-container>
            <ng-template #signInSubtitle>
              {{
                tenantName()
                  ? t('header.subtitle.signInWithTenant', { target: tenantName() ?? '' })
                  : t('header.subtitle.signInDefault', { brand: t('brand.name') })
              }}
            </ng-template>
          </p>
        </div>
      </div>
      <div class="tenant-status" *ngIf="loadingTenant()">
        <mat-progress-spinner mode="indeterminate" diameter="16"></mat-progress-spinner>
        <span>{{ t('status.loadingTenant') }}</span>
      </div>
    </header>

    <section class="card-content">
      <div class="error-banner" *ngIf="errorMessage()">{{ errorMessage() }}</div>

      <form
        class="auth-form"
        [formGroup]="form"
        (ngSubmit)="onSubmitEmailPassword()"
        *ngIf="providerToggles().emailPassword"
        novalidate
      >
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>{{ t('form.email.label') }}</mat-label>
          <input matInput type="email" formControlName="email" autocomplete="email" [disabled]="submitInFlight()" />
          <mat-icon matSuffix>mail</mat-icon>
          <mat-error *ngIf="form.controls.email.hasError('required')">{{ t('form.email.errors.required') }}</mat-error>
          <mat-error *ngIf="form.controls.email.hasError('email')">{{ t('form.email.errors.email') }}</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>{{ t('form.password.label') }}</mat-label>
          <input
            matInput
            type="password"
            formControlName="password"
            [attr.autocomplete]="isCreatingAccount() ? 'new-password' : 'current-password'"
            [disabled]="submitInFlight()"
          />
          <mat-icon matSuffix>lock</mat-icon>
          <mat-error *ngIf="form.controls.password.hasError('required')">{{ t('form.password.errors.required') }}</mat-error>
          <mat-error *ngIf="form.controls.password.hasError('minlength')">{{ t('form.password.errors.minLength') }}</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width" *ngIf="isCreatingAccount()">
          <mat-label>{{ t('form.confirmPassword.label') }}</mat-label>
          <input
            matInput
            type="password"
            formControlName="confirmPassword"
            autocomplete="new-password"
            [disabled]="submitInFlight()"
          />
          <mat-icon matSuffix>lock</mat-icon>
          <mat-error *ngIf="form.controls.confirmPassword.hasError('required')">
            {{ t('form.confirmPassword.errors.required') }}
          </mat-error>
          <mat-error *ngIf="form.controls.confirmPassword.hasError('mismatch')">
            {{ t('form.confirmPassword.errors.mismatch') }}
          </mat-error>
        </mat-form-field>

        <button mat-raised-button color="primary" type="submit" class="submit-button" [disabled]="submitInFlight()">
          <mat-progress-spinner
            *ngIf="submitInFlight()"
            diameter="18"
            mode="indeterminate"
            class="button-spinner"
          ></mat-progress-spinner>
          <span>{{ t(submitButtonTranslationKey()) }}</span>
        </button>
      </form>

      <div class="mode-toggle" *ngIf="providerToggles().emailPassword">
        <span>{{ t(modeSwitchPrefixTranslationKey()) }}</span>
        <button
          mat-button
          type="button"
          class="mode-toggle-button"
          (click)="toggleAccountCreation()"
          [disabled]="submitInFlight()"
        >
          {{ t(modeSwitchLabelTranslationKey()) }}
        </button>
      </div>

      <div class="divider" *ngIf="providerToggles().emailPassword && showThirdPartyProviders()">
        <mat-divider></mat-divider>
        <span>{{ t(providerSectionTranslationKey()) }}</span>
        <mat-divider></mat-divider>
      </div>

      <div class="social-buttons" *ngIf="showThirdPartyProviders()">
        <button
          mat-stroked-button
          type="button"
          class="social-button google"
          (click)="signInWithGoogle()"
          [disabled]="submitInFlight()"
          *ngIf="providerToggles().google"
        >
          <mat-icon>g_translate</mat-icon>
          <span>{{ t('providers.google') }}</span>
        </button>
        <button
          mat-stroked-button
          type="button"
          class="social-button facebook"
          (click)="signInWithFacebook()"
          [disabled]="submitInFlight()"
          *ngIf="providerToggles().facebook"
        >
          <mat-icon>facebook</mat-icon>
          <span>{{ t('providers.facebook') }}</span>
        </button>
        <button
          mat-stroked-button
          type="button"
          class="social-button apple"
          (click)="signInWithApple()"
          [disabled]="submitInFlight()"
          *ngIf="providerToggles().apple"
        >
          <mat-icon>apple</mat-icon>
          <span>{{ t('providers.apple') }}</span>
        </button>
      </div>
    </section>

    <footer class="card-footer">
      <p>{{ t('footer.terms') }}</p>
    </footer>
  </mat-card>
</div>
